import { IssuerStatus, SuperintendentStatus } from "@ha/data/basic";
import { Selector } from "@ngxs/store";

import { SubscriptionInvitation } from "../models/subscription-invitation";
import { SubscriptionsState, SubscriptionsStateModel } from "./subscriptions.state";

export class SubscriptionsSelectors {
    @Selector([SubscriptionsState])
    public static invitations(state: SubscriptionsStateModel): SubscriptionInvitation[] {
        return state?.activeAndPendingSubscriptions?.filter((_) =>
            _.issuerStatus === IssuerStatus.pending || _.superintendentStatus === SuperintendentStatus.pending
        );
    }

    @Selector([SubscriptionsState])
    public static active(state: SubscriptionsStateModel): SubscriptionInvitation[] {
        return state?.activeAndPendingSubscriptions?.filter((_) =>
            _.issuerStatus === IssuerStatus.active || _.superintendentStatus === SuperintendentStatus.active
        );
    }

    @Selector([SubscriptionsSelectors.active, SubscriptionsSelectors.invitations])
    public static returnDelegationSubscriptions(
        activeSubscriptions: SubscriptionInvitation[],
        invitationSubscriptions: SubscriptionInvitation[],
    ): SubscriptionInvitation[] {
        return [...(activeSubscriptions ?? []), ...(invitationSubscriptions ?? [])]
            .reduce((subscriptions, subscription) => {
                const existingSubscription = subscriptions.find((_) => _.subscriptionId === subscription.subscriptionId);

                if (existingSubscription == null) {
                    subscriptions.push({ ...subscription });
                    return subscriptions;
                }

                if (subscription.issuerStatus === IssuerStatus.active) {
                    existingSubscription.issuerStatus = subscription.issuerStatus;
                }

                if (subscription.superintendentStatus === SuperintendentStatus.active) {
                    existingSubscription.superintendentStatus = subscription.superintendentStatus;
                }

                return subscriptions;
            }, [] as SubscriptionInvitation[])
            .filter((subscription) =>
                subscription.issuerStatus === IssuerStatus.active || subscription.superintendentStatus === SuperintendentStatus.active
            );
    }

    @Selector([SubscriptionsSelectors.returnDelegationSubscriptions])
    public static hasDelegationsToReturn(subscriptions: SubscriptionInvitation[]): boolean {
        return (subscriptions?.length ?? 0) > 0;
    }

    @Selector([SubscriptionsSelectors.active])
    public static hasActiveSubscription(activeSubscriptions: SubscriptionInvitation[]): boolean {
        return activeSubscriptions?.length > 0;
    }

    @Selector([SubscriptionsState])
    public static returningCurrentUserDelegation(state: SubscriptionsStateModel): boolean | undefined {
        return state?.returningCurrentUserDelegation;
    }

    @Selector([SubscriptionsState])
    public static returnCurrentUserDelegationSucceeded(state: SubscriptionsStateModel): boolean | undefined {
        return state?.returnCurrentUserDelegationSucceeded;
    }

    @Selector([SubscriptionsState])
    public static returnCurrentUserDelegationErrorMessage(state: SubscriptionsStateModel): string | undefined {
        return state?.returnCurrentUserDelegationErrorMessage;
    }
}
